import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class BookmarkletController implements Controller {
  public pageId = 'Bookmarklet';
  public path = '/:localeName/bookmarklet';
  public routeName = 'bookmarklet';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/bookmarklet-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Bookmarklet' }) as Promise<PageData>;
  }
}
